import Apresentacao from 'componentes/Apresentacao'
import React from 'react'
import styles from './Contato.module.css'
import { AiFillLinkedin, AiOutlineWhatsApp, AiOutlineMail } from 'react-icons/ai'
import { motion } from 'framer-motion'


export default function Contato() {
  return (
    <motion.div
      initial={{ opacity: 0}}
      animate={{opacity: 1}}
      exit={{opacity:0}}
      className={styles.container}
    >
      <div className={styles.info}>
        <h2>Bruno Bahy</h2>
        <p>Contatos</p>
        <img className={styles.imagem} src="http://github.com/brunobahy.png" alt="Foto do Bruno Bahy, acesse http://github.com/brunobahy.png para ver" />
      </div>
      <ul className={styles.lista}>
        <li className={styles.itens}>
          <a href="https://api.whatsapp.com/send?phone=5551986197486" >
            <AiOutlineWhatsApp size={60} color="white" />
            <h2>WhatsApp</h2>
          </a>
        </li>
        <li className={styles.itens} >
          <a href="https://www.linkedin.com/in/bruno-bahy" >
            <AiFillLinkedin size={60} color="white" />
            <h2>Linkedin</h2>
          </a>
        </li>
        <li className={styles.itens}>
          <a href="mailto:bruno.bahy.oliveira@gmail.com" >
            <AiOutlineMail size={60} color="white" />
            <h2>Email</h2>
          </a>
        </li>
      </ul>
    </motion.div>
  )
}
